import UsersFeedback from "./UsersFeedback";
export default UsersFeedback;
